import cn from 'classnames';

const UserFlowHeader = ({ headerText, classes }: { headerText: string; classes?: string }) => (
  <>
    <h1 className={cn(classes, 'h3 text-align-center wordBreak')}>{headerText}</h1>
    <style jsx>{`
      .wordBreak {
        word-break: break-word;
      }
    `}</style>
  </>
);

export default UserFlowHeader;
